import { loadingAction } from '../actions.js';
import { url } from "../../config";
import { toast } from 'react-hot-toast';
import { authAction, registrationAction } from "../actions";
import { REGISTRATION_FORM_INITIAL } from "../initialStateConstants";
import { setRegistrationDocsAction } from "../reducer";

const request = data => {
    return fetch(`${ url }/get_registration_docs`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

export const GetRegistrationDocsThunk = (args) => async (dispatch, getState) => {
    const { est, auth_form } = getState();

    dispatch(loadingAction(true));

    try {
        let formData = new FormData();
        formData.append('slug', est.slug);
        formData.append('est', est.id);

        const response = await request(formData);

        if (response.success) {
            dispatch(setRegistrationDocsAction(response.payload));

            // Закрываем форму авторизации
            dispatch(authAction({
                ...auth_form,
                open: false
            }));
            // Открываем форму регистрации
            dispatch(registrationAction({
                ...REGISTRATION_FORM_INITIAL,
                open: true
            }));
        }
        else if (response.error) {
            toast.error(response.message);
        }
    }
    catch (error) {
        console.log(error);
    }
    finally {
        dispatch(loadingAction(false));
    }
};